// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b3780f74","453":"e163f550"}[chunkId] + ".chunk.js";
};